import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CostMgmtComponent} from './cost-mgmt.component';
import {CostMgmtRoutingModule} from 'src/app/main/cost-mgmt/cost-mgmt-routing.module';
import {BreadcrumbModule} from '../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    CostMgmtComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    CostMgmtRoutingModule
  ]
})
export class CostsMgmtModule {
}
